import React, { useEffect, useState, useMemo } from "react";
import CustomAutocomplete from "../../../components/CustomAutoComplete";
import {useDispatch, useSelector} from "react-redux";
import {concat2String, concat3String, formatName, formatPadStartNumber, formatYear, getAge,
  formatDateTime, getAgeByYearMonthDay, formatJoinLeaveCompanyDate} from "utils/format";
import talentAvatar from '../../../../assets/img/noAvatar.png';
import {ThunkDispatch} from "@reduxjs/toolkit";
import {
  getListTalentRecommend,
  getDetailTalentChat,
  setTalentSelected, getActions,
  setIsOpenListJobPanel, setJobSelected, getListJobRecommend, setIsScout,
  setIsMessageFormDirty,
  setPendingPath,
  setIsDiscardUnsentMessagePopup
} from "reducers/chatMessage";
import { setActionName, setActionStatus } from "reducers/action";
import CustomIconButton from "../../../components/CustomIconButton";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import CustomToast from "../../../components/CustomToast";
import {SYSTEM_USER_NAME, MESSAGE_TYPE, STAFF_TYPE} from "../../../constants/index";
import CheckboxButton from "../../../components/CheckboxButton";
import ConfirmPopup from "../../../components/ConfirmPopup";
import StatusSelectionModal from "./StatusSelectionModal";
import CustomTooltip from "../../../components/CustomTooltip";
import i18n from 'i18next';
import { useSnackbar } from "notistack";

const ChatBoxHeader = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const {staffInfo} = useSelector((state: any) => state.currentUser);
  const { chatSelected, isChatting, talentSelected, jobSelected, isScout,
    listTalentRecommend, isOpenListJobPanel, isNewChat, action, actionItems,
    isNewChatFormOtherScreen, isMessageFormDirty, isDiscardUnsentMessagePopup } = useSelector((state: any) => state.chatMessage);
  const { actionStatus, actionName, isSuccess, apiMessage } = useSelector((state: any) => state.action);
  const [isExpanded, setIsExpanded] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isScoutConfirmPopup, setIsScoutConfirmPopup] = useState(false);
  const [isStatusSelectionModalOpen, setIsStatuSelectionModalOpen] = useState(false);
  const [talentActive, setTalentActive] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!chatSelected.id) {
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
    }
  }, [chatSelected]);

  useEffect(() => {
    if(isNewChat) {
      setTalentActive(null);
    }
  }, [isNewChat])

  useEffect(() => {
    if(talentSelected && talentSelected?.id && typeof talentSelected?.is_active === "boolean") {
      setTalentActive(talentSelected?.is_active);
    } else {
      setTalentActive(null);
    }
  }, [talentSelected])

  const isTalentActive = useMemo(() => {
    if (isNewChat) return null; 
    
    if (talentSelected && talentSelected.id && typeof talentSelected.is_active === "boolean") {
      return talentSelected.is_active;
    }
    
    return null;
  }, [talentSelected, isNewChat]);

  // Show toast
  useEffect(() => {
    if (window.location.href.includes('company/message') && actionStatus === 'fulfilled' && actionName == 'addActionItems') {
      if(!isSuccess) {
        showToast('メッセージ', apiMessage, "error");
      } else {
        showToast('メッセージ', i18n.t('MSG_ACTION_ADD_SUCCESS'), "success");
        setIsStatuSelectionModalOpen(false)
      }
      dispatch(getActions({ chatConversationId: chatSelected?.id }));
      dispatch(setActionName(""));
      dispatch(setActionStatus("idle"));
      if(chatSelected?.talent?.id) {
        dispatch(getDetailTalentChat({ id: chatSelected?.talent?.id }));
      }
    }
  }, [actionStatus, actionName]);

  const showToast = (title: any, mes: any, variant: any) => {
    enqueueSnackbar("I love snacks.", {
      autoHideDuration: 7000,
      content: (key) => (
        <CustomToast title={title} message={mes} variant={variant}
          snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  const handleSelectTalent = (item: any) => {
    dispatch(getDetailTalentChat({ id: item.value }));

    // Get list job recommend
    const dataJob = { search: '', talentId: item.value }
    dispatch(getListJobRecommend(dataJob));
  };

  // Handle change input
  const handleInputChange = (value: any) => {
    setInputValue(value);
    dispatch(getListTalentRecommend({ search: value }));
  };

  const unSelectTalent = () => {
    dispatch(setTalentSelected({}));
  };

  const unSelectJob = () => {
    dispatch(setJobSelected({}));
  };

  const handleSetIsOpenListJobPanel = () => {
    if(!talentSelected?.id) {
      return
    }
    if(chatSelected?.type?.value == MESSAGE_TYPE.SCOUT || chatSelected?.type?.value == MESSAGE_TYPE.APPLY) {
      return
    }
    dispatch(setIsOpenListJobPanel(true));
  };

  const handleGoToJob = (e: any, jobId: number) => {
    e.stopPropagation()
    if(isMessageFormDirty && !isDiscardUnsentMessagePopup) {
      dispatch(setIsDiscardUnsentMessagePopup(true));
      dispatch(setPendingPath("/company/job/detail/" + jobId));
    } else {
      if(jobId) navigate("/company/job/detail/" + jobId);
    }
  }

  const navigateToActionDetail = () => {
    if(isMessageFormDirty && !isDiscardUnsentMessagePopup) {
      dispatch(setIsDiscardUnsentMessagePopup(true));
      dispatch(setPendingPath("/company/action/edit/" + action?.id));
    } else {
      if(action?.id) navigate("/company/action/edit/" + action?.id);
    }
  }

  const handleScoutCheck = () => {
    dispatch(setIsMessageFormDirty(true));
    if(isScout) {
      if(jobSelected?.id) {
        setIsScoutConfirmPopup(true);
      } else dispatch(setIsScout(false));
    } else {
      dispatch(setIsScout(true));
    }
  }

  const isShowSelectedJob = () => {
    if(!chatSelected?.id) {
      if(isScout) {
        return true
      } else {
        return false
      }
    } else {
      if(jobSelected?.id) {
        return true
      } else {
        return false
      }
    }
  }

  return (
    <>
    <div className="mb-2">
      {!chatSelected?.id && isChatting && (
        <div className="flex items-center gap-2 mb-2">
          <h2 className="font-bold alu-text-base-2 text-xl">
            新規メッセージ
          </h2>
          <CheckboxButton
            name="scout"
            label="スカウトする"
            value={isScout}
            onChange={handleScoutCheck}
            disabled={!talentActive}
          />
        </div>
      )}
      <div className={`${isShowSelectedJob() ? 'mb-2' : ''} ${!talentSelected?.id || (chatSelected?.id && !isExpanded) ? 'items-center' : ''} flex gap-2 xl:gap-4`}>
        <label
          className="block shrink-0 min-w-[4rem] text-sm font-bold alu-text-base-2"
          htmlFor="email"
        >
          宛先
        </label>
        {!talentSelected?.id ? (
          <CustomAutocomplete
            placeholder={"メールアドレスを入力..."}
            options={listTalentRecommend}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onChange={(item: any) => {handleSelectTalent(item); dispatch(setIsMessageFormDirty(true));}}
            controlHeight={45}
          />
        ) : isExpanded ? (
          <div className="flex-1 p-3 rounded-lg border border-[#E0E0E0]">
            <div className="flex gap-3">
              <img
                className="shrink-0 w-[48px] h-[48px] rounded-full object-cover"
                src={talentSelected?.talent?.avatar ? talentSelected?.talent?.avatar : talentAvatar}
              />
              <div className="flex-1 flex flex-col gap-1">
                <div className="flex items-start gap-2">
                  <h5 className="text-base font-bold alu-text-base-2 break-all">
                    {talentSelected?.talent?.first_name ? formatName(talentSelected?.talent?.first_name, talentSelected?.talent?.last_name) : chatSelected.is_from_system ? SYSTEM_USER_NAME : ''}
                    {isTalentActive === false && talentSelected?.id && (
                      <span className="font-normal text-xs">（退会済み）</span>
                    )}
                  </h5>
                  <span className="shrink-0 rounded-2xl bg-[#e0e0e0] text-[#343a3d] text-sm px-2 py-0.5">{talentSelected?.status}</span>
                </div>
                <div className="flex gap-2">
                  <p className="min-w-16 shrink-0 text-sm alu-text-base-1 leading-[21px]">最終部署</p>
                  <p className="flex-1 text-sm alu-text-base-2">{concat2String(talentSelected?.department, talentSelected?.position)}</p>
                </div>
                <div className="flex gap-2">
                  <p className="min-w-16 shrink-0 text-sm alu-text-base-1 leading-[21px]">在籍期間</p>
                  <p className="flex-1 text-sm alu-text-base-2">
                    {formatJoinLeaveCompanyDate(talentSelected?.join_company_year, talentSelected?.join_company_month, talentSelected?.leave_company_year, talentSelected?.leave_company_month)}
                  </p>
                </div>
                <div className="flex gap-2">
                  <p className="min-w-16 shrink-0 text-sm alu-text-base-1 leading-[21px]">現職</p>
                  <p className="flex-1 text-sm alu-text-base-2">
                    {talentSelected?.talent?.current_company_name ?? "ー"}
                  </p>
                </div>
                <div className="flex gap-2">
                  <p className="min-w-16 shrink-0 text-sm alu-text-base-1 leading-[21px]">年齢</p>
                  <p className="flex-1 text-sm alu-text-base-2">{getAgeByYearMonthDay(talentSelected?.talent?.birth_year, talentSelected?.talent?.birth_month, talentSelected?.talent?.birth_day)}</p>
                </div>
              </div>

              <div className="flex flex-col gap-3 self-center">
                <div className="py-2 px-4 flex-1 rounded-lg bg-[#F7F7F7] max-h-min w-[160px] flex flex-col justify-center">
                  <p className="text-sm alu-text-base-1 text-center">
                    副業意欲
                  </p>
                  <p className="text-sm alu-text-base-2 font-bold text-center">
                    {talentSelected?.talent?.work_part_time_status ? talentSelected?.talent?.work_part_time_status.name : '-'}
                  </p>
                </div>
                <div className="py-2 px-4 flex-1 rounded-lg bg-[#F7F7F7] max-h-min w-[160px] flex flex-col justify-center">
                  <p className="text-sm alu-text-base-1 text-center">
                    転職意欲
                  </p>
                  <p className="text-sm alu-text-base-2 font-bold text-center">
                    {talentSelected?.talent?.change_job_status ? talentSelected?.talent?.change_job_status.name : '-'}
                  </p>
                </div>
              </div>
              {chatSelected?.id && <CustomIconButton
                customStyle="shrink-0"
                onClick={() => setIsExpanded((prev) => !prev)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8.00001L6 14L7.41 15.41Z" fill="currentColor"/>
                </svg>
              </CustomIconButton>}
            </div>
          </div>
        ) : (
          <div className="w-full px-2 py-1 flex items-center gap-4 rounded-lg border border-[#E0E0E0]">
            <img
              className="shrink-0 w-[40px] h-[40px] rounded-full object-cover"
              src={talentSelected?.talent?.avatar ? talentSelected?.talent?.avatar : talentAvatar}
              alt={talentSelected?.talent?.first_name ? formatName(talentSelected?.talent?.first_name, talentSelected?.talent?.last_name) : chatSelected.is_from_system ? SYSTEM_USER_NAME : ''}
            />
            <div className="flex-1 flex items-center gap-4">
              <p className="text-base font-bold alu-text-base-2">
              {talentSelected?.talent?.first_name ? formatName(talentSelected?.talent?.first_name, talentSelected?.talent?.last_name) : chatSelected.is_from_system ? SYSTEM_USER_NAME : ''}
              {isTalentActive === false && talentSelected?.id && (
                <span className="font-normal text-xs">（退会済み）</span>
              )}
              </p>
              <span className="shrink-0 rounded-2xl bg-[#e0e0e0] text-[#343a3d] text-sm px-2 py-0.5">{talentSelected?.status}</span>
            </div>
            {chatSelected?.id && <CustomIconButton
              customStyle="shrink-0"
              onClick={() => setIsExpanded((prev) => !prev)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_5980_460)">
                  <path d="M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z" fill="currentColor"/>
                </g>
                <defs>
                  <clipPath id="clip0_5980_460">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </CustomIconButton>}
          </div>
        )}
        {talentSelected?.id && !chatSelected?.id && (
          <CustomIconButton customStyle="shrink-0 self-start" onClick={unSelectTalent}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M200-440v-80h560v80H200Z"/></svg>
          </CustomIconButton>
        )}
      </div>
      
      { isShowSelectedJob() && 
        <div className="flex gap-4 items-center">
          <label
            className="block shrink-0 min-w-[4rem] text-sm font-bold alu-text-base-2"
            htmlFor="email"
          >
            求人情報
          </label>
          {!jobSelected?.id ? (
            <CustomButton
              disabled={isOpenListJobPanel || !talentSelected?.id || !talentActive}
              onClick={handleSetIsOpenListJobPanel}
              variant="outline"
              size="md"
            >
              求人を選ぶ
            </CustomButton>
          ) : (
            <>
              <div onClick={handleSetIsOpenListJobPanel} 
              className={`w-full ${chatSelected?.type?.value == MESSAGE_TYPE.SCOUT || chatSelected?.type?.value == MESSAGE_TYPE.APPLY ? "" : "hover:cursor-pointer"} px-2 py-1 flex items-center gap-4 justify-between`}>
                <p className="flex-1 text-sm alu-text-base-1">
                  <u className="alu-text-base-1 cursor-pointer hover:text-[#FF861A]" onClick={(e: any) => handleGoToJob(e, jobSelected?.id)}>{jobSelected?.title}</u>
                  <span className="ml-[0.875rem] alu-text-base-1">id: {formatPadStartNumber(jobSelected?.id, 5)}</span>
                </p>
                <div className="min-w-[100px] shrink-0 flex items-center gap-1 rounded-[0.25rem] bg-[#F7F7F7] px-2 py-[0.375rem]">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                    >
                      <circle cx="6.75" cy="6.5" r="6" fill={jobSelected?.is_available ? '#06C270' : '#BBB'} />
                    </svg>
                  </span>
                  <p className="text-sm alu-text-base-2">{jobSelected?.status_str}</p>
                </div>
              </div>
              {!chatSelected?.id ? (
                <CustomIconButton customStyle="shrink-0 self-start" onClick={unSelectJob}>
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M200-440v-80h560v80H200Z"/></svg>
                </CustomIconButton>
              ): ''}
            </>
          )}
        </div>
      }

      {isChatting && talentSelected?.id && actionItems.length !== 0 && <div className="flex gap-4 items-center mt-1">
        <label
          className="block shrink-0 min-w-[4rem] text-sm font-bold alu-text-base-2"
          htmlFor="announcement"
        >
          連絡事項
        </label>
        <div className={`flex-1 px-2 py-1 flex items-center gap-4 justify-between`}>
          <CustomTooltip content={
            <div className="text-sm">
              <p className="alu-text-base-1 shrink-0 mb-1 break-words break-all">{formatName(actionItems[0]?.staff?.first_name, actionItems[0]?.staff?.last_name)}：
                <span className="ml-1 alu-text-base-2">{actionItems[0]?.content}</span>
              </p>
              <p className="alu-text-base-1 shrink-0 mb-4">
                <span className="alu-text-base-1">{formatDateTime(actionItems[0]?.created_at)}</span>
              </p>
              <CustomButton variant="text" type="button" onClick={() => navigateToActionDetail()}>
                → 選考状況の詳細を見る
              </CustomButton>
            </div>
          }>
            <div className="w-[90%] flex items-center text-sm alu-text-base-1 whitespace-pre-wrap break-words break-all">
              {actionItems[0]?.staff && <p className="alu-text-base-1 shrink-0">{formatName(actionItems[0]?.staff?.first_name, actionItems[0]?.staff?.last_name)}：</p>}
              <p className="ml-1 alu-text-base-2 line-clamp-1">{actionItems[0]?.content}</p>
            </div>
          </CustomTooltip>
          <div className="shrink-0">
            <CustomButton variant="text" type="button" onClick={() => setIsStatuSelectionModalOpen(true)} disabled={!talentActive || staffInfo?.type == STAFF_TYPE.GENERAL}>
              選考状況を更新
            </CustomButton>
          </div>
        </div>
      </div>}
    </div>
    {isScoutConfirmPopup && <ConfirmPopup
          open={isScoutConfirmPopup}
          onClose={() => setIsScoutConfirmPopup(false)}
          confirmContent={"通常のメッセージに戻してもよろしいですか？"}
          confirmDescription={"スカウトメッセージを通常のメッセージに戻すと、選択した求人情報は送信できません。"}
          onConfirm={() => {dispatch(setIsScout(false)); setIsScoutConfirmPopup(false)}}
          cancelText={"キャンセル"}
          confirmText={"通常のメッセージに戻す"}
    />}
    {isStatusSelectionModalOpen &&
      <StatusSelectionModal 
        open={isStatusSelectionModalOpen}
        onClose={() => setIsStatuSelectionModalOpen(false)}
      />
    }
    </>
  );
};

export default ChatBoxHeader;
